import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { Supplier, SupplierCreateDTO, SupplierResponse } from '../interfaces/procurement/supplier.interface';

export const SupplierService = {
  listByInstitution: async (page = 0, size = 10): Promise<SupplierResponse> => {
    const institutionId = AuthService.getSelectedInstitution()!!;
    const res = await axios.get(`${ENDPOINTS.SUPPLIER.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`);
    return res.data;
  },
  getById: async (id: string): Promise<Supplier> => (await axios.get(ENDPOINTS.SUPPLIER.GET_BY_ID(id))).data,
  create: async (dto: SupplierCreateDTO): Promise<Supplier> => (await axios.post(ENDPOINTS.SUPPLIER.CREATE, dto)).data,
  update: async (id: string, dto: SupplierCreateDTO): Promise<Supplier> => (await axios.put(ENDPOINTS.SUPPLIER.UPDATE(id), dto)).data,
  delete: async (id: string): Promise<void> => { await axios.delete(ENDPOINTS.SUPPLIER.DELETE(id)); },
};
